import IconContainer, { IconContainerProps } from "./IconContainer"

export default function IconCalendar(props: IconContainerProps) {
    return <IconContainer size={props.size}>
        calendar_month
    </IconContainer>
}
